<!-- 以后项目的根组件 -->
<template>
	<router-view></router-view>
</template>

<script>
// import tool from './kits/Tools';
export default {
	data(){
		return{
			token:"",
		}
	},
	async created() {
		// console.log("p22222",process.env);
  	},
}
</script>

<style scoped>
</style>